module.exports = __webpack_public_path__ + "cca4a6f8b0bc3479148e63bd7b23e5de.svg";